import { gql } from '@apollo/client';

export const GET_USERS = gql`
  query GET_USERS {
    users {
      id
      netId
      role
      disabled
    }
  }
`;

export const GET_USER = gql`
  query GET_USER($id: ID!) {
    user(id: $id) {
      id
      netId
      role
      disabled
    }
  }
`;

export const EDIT_USER = gql`
  mutation EDIT_USER($id: ID!, $input: UpdateUserInput!) {
    editUser(id: $id, input: $input) {
      id
      role
      netId
      disabled
    }
  }
`;

export const TOGGLE_USER_DISABLED = gql`
  mutation TOGGLE_USER_DISABLED($id: ID!, $input: UpdateUserInput!) {
    editUser(id: $id, input: $input) {
      id
      disabled
    }
  }
`;

export const DELETE_USER = gql`
  mutation DELETE_USER($id: ID!) {
    deleteUser(id: $id)
  }
`;

export const ADD_USER = gql`
  mutation ADD_USER($input: UpdateUserInput!) {
    addUser(input: $input) {
      id
    }
  }
`;
